import {dateRangeFilterFn, fuzzyTextFilterFn} from "./filterFunctions";

export const getFilterTypes = () => ({
    // Fuzzy text filter
    fuzzyText: fuzzyTextFilterFn,
    // Or, override the default text filter to use
    // "startWith"
    text: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue)
                    .toLowerCase()
                    .startsWith(String(filterValue).toLowerCase())
                : true;
        });
    },
    dateRange: dateRangeFilterFn,
})
